import React, { useState, useRef, useEffect } from 'react';
import { FaCaretDown, FaSearch } from 'react-icons/fa';
import './Filter.css'; // Reuse the same CSS file for styling

const FilterTreatments = ({ 
    searchText, 
    setSearchText, 
    viewOption, 
    setViewOption 
}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState(null); // State for the selected filter
    const dropdownRef = useRef(null); // Reference for the dropdown container

    // Event listener to close dropdown when clicked outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    // Handle dropdown selection
    const handleFilterSelection = (filter) => {
        setSelectedFilter(filter); // Set the selected filter
        setViewOption(filter); // Update the parent view option
        setIsDropdownOpen(false); // Close the dropdown
    };

    // Remove filter
    const handleRemoveFilter = () => {
        setSelectedFilter(null); // Reset the filter
        setViewOption(''); // Reset the parent view option
    };

    // Filter options for treatments
    const filterOptions = [
        { value: 'archived', label: 'Archived Treatments' }, // Show only archived treatments
    ];

    return (
        <div className="search-bar">
            {/* Search Input */}
            <input
                type="text"
                placeholder="Search Treatments"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="table-search-input"
            />

            {/* Selected Filter Display */}
            {selectedFilter && (
                <div className="selected-filter">
                    {filterOptions.find(option => option.value === selectedFilter)?.label}
                    <button className="remove-filter-btn" onClick={handleRemoveFilter}>
                        ✕
                    </button>
                </div>
            )}

            {/* Dropdown for Filter Options */}
            <div className="patients-dropdown-container" ref={dropdownRef}>
                <FaCaretDown
                    className="patients-dropdown-icon-1"
                    onClick={() => setIsDropdownOpen((prev) => !prev)}
                />
                {isDropdownOpen && (
                    <div className="patients-dropdown-options">
                        {filterOptions.map((option) => (
                            <div 
                                key={option.value} 
                                onClick={() => handleFilterSelection(option.value)}
                            >
                                {option.label}
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Search Icon */}
            <FaSearch className="search-icon" />
        </div>
    );
};

export default FilterTreatments;